import React from 'react';
// styles
const styles = require('./loading-screen.scss');

class LoadingScreenComponent extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  render() {
    return(
      <div className={styles.loader}></div>
    );
  }

}

export default LoadingScreenComponent;



// WEBPACK FOOTER //
// ./src/components/loader/loading-screen.component.tsx